<template>
  <div>
    <b-container fluid class="mt-2">
      <b-card
        no-body
        :header="category.title"
        v-for="(category, categoryIndex) in notes"
        :key="'cat-' + categoryIndex"
        class="mb-2 rounded-0"
        header-class="p-1 font-weight-bold font-small"
      >
        <b-list-group flush>
          <b-list-group-item
            class="p-0 rounded-0"
            v-for="(ingredient, ingredientIndex) in category.entries"
            :key="'ing-' + categoryIndex + '-' + ingredientIndex"
          >
            <b-input-group size="sm">
              <template v-slot:append>
                <b-btn
                  size="sm"
                  variant="light"
                  class="border-left px-1 py-0"
                  @click="markChecked(categoryIndex, ingredientIndex)"
                >
                  <b-icon-x class="text-danger" />
                </b-btn>
              </template>
              <b-form-input
                class="rounded-0 border-0"
                v-model="ingredient.title"
                @change="saveState"
              ></b-form-input>
            </b-input-group>
          </b-list-group-item>
          <b-btn
            @click.stop="addNote(categoryIndex)"
            size="sm"
            variant="light"
            block
            class="px-1 py-0 rounded-0"
            ><b-icon-plus class="text-primary"
          /></b-btn>
        </b-list-group>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { UnitOptions } from "@/class/recipe";
export default {
  name: "Notes",
  data() {
    return { unitOptions: UnitOptions };
  },
  computed: mapState({
    // arrow functions can make the code very succinct!
    notes: state => state.notes,
    searchActive: state => state.searchActive
  }),
  methods: {
    markChecked(categoryIndex, ingredientIndex) {
      this.$store.dispatch("deleteNote", {
        categoryIndex: categoryIndex,
        ingredientIndex: ingredientIndex
      });
    },
    addNote(categoryIndex) {
      this.$store.commit("ADD_NOTE", categoryIndex);
    },
    saveState() {
      this.$store.dispatch("saveState");
    }
  }
};
</script>

<style lang="scss">
.font-small {
  font-size: 0.8em;
}
</style>
